module.exports = __webpack_public_path__ + "img/kumquats-350x184.d192b080.jpg";